/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FaxFilterOption } from './FaxFilterOption';
import {
    FaxFilterOptionFromJSON,
    FaxFilterOptionFromJSONTyped,
    FaxFilterOptionToJSON,
    FaxFilterOptionToJSONTyped,
} from './FaxFilterOption';

/**
 * 
 * @export
 * @interface FaxFilterOptionsResponse
 */
export interface FaxFilterOptionsResponse {
    /**
     * Up to 50 sender fax numbers matching the search, most frequent first
     */
    senders: Array<FaxFilterOption>;
    /**
     * 
     */
    recipients: Array<FaxFilterOption>;
}

/**
 * Check if a given object implements the FaxFilterOptionsResponse interface.
 */
export function instanceOfFaxFilterOptionsResponse(value: object): value is FaxFilterOptionsResponse {
    if (!('senders' in value) || value['senders'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function FaxFilterOptionsResponseFromJSON(json: any): FaxFilterOptionsResponse {
    return FaxFilterOptionsResponseFromJSONTyped(json, false);
}

export function FaxFilterOptionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxFilterOptionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'senders': ((json['senders'] as Array<any>).map(FaxFilterOptionFromJSON)),
        'recipients': ((json['recipients'] as Array<any>).map(FaxFilterOptionFromJSON)),
    };
}

export function FaxFilterOptionsResponseToJSON(json: any): FaxFilterOptionsResponse {
    return FaxFilterOptionsResponseToJSONTyped(json, false);
}

export function FaxFilterOptionsResponseToJSONTyped(value?: FaxFilterOptionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'senders': ((value['senders'] as Array<any>).map(FaxFilterOptionToJSON)),
        'recipients': ((value['recipients'] as Array<any>).map(FaxFilterOptionToJSON)),
    };
}

